import React from 'react'

// Declare the build-time constants that Vite will replace (see vite.config.ts)
declare const __BUILD_TIME__: string
declare const __APP_VERSION__: string

// Version utility for displaying build information
export const getVersionInfo = () => {
  // Use build time set at build time
  const buildTime = __BUILD_TIME__
  const buildDate = new Date(buildTime).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
  const buildTimeFormatted = new Date(buildTime).toLocaleTimeString('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit'
  })
  
  return {
    version: __APP_VERSION__,
    buildDate,
    buildTime: buildTimeFormatted,
    fullVersion: `v${__APP_VERSION__} • ${buildDate} ${buildTimeFormatted}`
  }
}

export const VersionDisplay: React.FC = () => {
  const { fullVersion } = getVersionInfo()
  
  return (
    <div className="bg-neutral-50 border-t border-neutral-200">
      <div className="text-xs text-neutral-500 text-center py-2 px-4">
        {fullVersion}
      </div>
    </div>
  )
} 